import { Loader2 } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { NuwweFormData } from "../types";

type NuwweErpFormProps = {
  formData: NuwweFormData;
  onFormDataChange: (data: Partial<NuwweFormData>) => void;
  existingConfig: { merchantUrl?: string; empresa?: string; hasToken: boolean } | null;
  isLoading: boolean;
  onSave: () => void;
};

const SENSITIVE_HINT = "Deja en blanco para mantener el valor actual, o ingresa uno nuevo para actualizar";

const NuwweErpForm = ({
  formData,
  onFormDataChange,
  existingConfig,
  isLoading,
  onSave,
}: NuwweErpFormProps): JSX.Element => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Credenciales Nuwwe</h3>
        {existingConfig?.hasToken && (
          <span className="text-sm font-medium text-green-600">Conexion exitosa</span>
        )}
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <Label className="text-sm font-medium text-gray-700 mb-1.5 block">URL del Merchant</Label>
          <Input
            type="text"
            placeholder="https://api.nuwwe.com"
            value={formData.merchantUrl}
            onChange={(e) => onFormDataChange({ merchantUrl: e.target.value })}
            className="bg-gray-50 hover:border-gray-300 focus:border-purple-500 focus:bg-white"
          />
        </div>
        <div>
          <Label className="text-sm font-medium text-gray-700 mb-1.5 block">Empresa</Label>
          <Input
            type="text"
            placeholder="Identificador de empresa"
            value={formData.empresa}
            onChange={(e) => onFormDataChange({ empresa: e.target.value })}
            className="bg-gray-50 hover:border-gray-300 focus:border-purple-500 focus:bg-white"
          />
        </div>
        <div>
          <Label className="text-sm font-medium text-gray-700 mb-1.5 block">Token</Label>
          <Input
            type="password"
            placeholder={existingConfig?.hasToken ? "••••••••" : "Token de autenticacion"}
            value={formData.token}
            onChange={(e) => onFormDataChange({ token: e.target.value })}
            className="bg-gray-50 hover:border-gray-300 focus:border-purple-500 focus:bg-white"
          />
          {existingConfig?.hasToken && (
            <p className="mt-1 text-xs text-gray-500">{SENSITIVE_HINT}</p>
          )}
        </div>
        <div className="pt-2">
          <Button variant="main" onClick={onSave} disabled={isLoading}>
            {isLoading && <Loader2 className="mr-2 size-4 animate-spin" />}
            Guardar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NuwweErpForm;
